module.exports = __webpack_public_path__ + "static/media/ArrowDown.c6034392.svg";